/**
 * External dependencies
 */

import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

/**
 * Internal dependencies
 */
import './styles.scss';
import FormLabel from 'components/forms/form-label';

const FormInputFloatingLabel = ({ label, FormInput, ...rest }) => {
    const [focused, setFocused] = useState(false);
    const classes = classNames('form-floating-label', {
        'form-floating-label--focused': focused,
        'form-floating-label--has-input': rest.value.length >= 1,
    });

    return (
        <div className={classes}>
            <FormInput autoComplete="off" {...rest} onBlur={() => setFocused(false)} onFocus={() => setFocused(true)} />
            <FormLabel className='form-floating-label__label'>{label}</FormLabel>
            <div className='form-floating__ripple' />
        </div>
    );
};

FormInputFloatingLabel.propTypes = {};

export default FormInputFloatingLabel;
